;"use strict";

//const jquery = require('./jquery-1.10.1.min');
import jquery from 'jquery';
window.$ = window.jQuery = jquery;

import State from './state';
import MainTable from './maintable';
import RegSelector from './regselector';
import Calc from './calc';
import Printer from './print';
import sha256 from 'crypto-js/sha256';

$(document).ready(function(){

	var str;

	State.hideLoadBanner = hideLoadBanner;
	var regSelector = new RegSelector();
	var calc = new Calc();
	State.calc = calc;
	var printer = new Printer();

	State.calc = calc;

	var mainTable = new MainTable(); 
	State.mainTable = mainTable;
	State.regSelector = regSelector;
	State.printer = printer;

	loadSetup();

//	regSelector.initRegData();

	$('#hmenu').on(State.startEvent, (e)=>switchPage(e));
	$('#setup-close-but').on(State.startEvent, (e)=>closeSetupPanel(e));
	$('.setup-button').on(State.startEvent, (e)=>setupAction(e));

	// $('#pass-input').on('keypress', (e)=>checkLogin(e));
	// $('#login-butt').on(State.startEvent, (e)=>checkLogin(e));
	$('#pass-input').on('keypress', (e)=>State.calc.getUserData(e));
	$('#login-butt').on(State.startEvent, (e)=>State.calc.getUserData(e));
	$('#gen-input').on('input', (e)=>showGText(e));
	$('#gen-close-but').on(State.startEvent, (e)=>closeGenPanel(e));

	var nonce = 'gdsnboduwcglk', data = 'doctor', noa = 'gfhksirlcgysbs';
	var hashDigest = sha256(nonce + data);
	if(hashDigest.words[0]<0) hashDigest.words[0] = 0-hashDigest.words[0];
	var checkData = sha256(nonce + hashDigest.words[0]).toString();
console.log(checkData);
	console.log(hashDigest.words[0]);
	data = 'marketnavadm';
	hashDigest = sha256(noa + data);
	if(hashDigest.words[0]<0) hashDigest.words[0] = 0-hashDigest.words[0];
	console.log(hashDigest.words[0]);
	window.showSetupPanel = showSetupPanel;
	window.checkLogin = checkLogin;
});


function enterGen() {

	$('#p-gen').show();
}

function closeGenPanel() {

	$('#p-gen').hide();
}

function showGText(e) {

	var key, n, p, h, res, str;
	var no = 'gdsnboduwcglk';

	n = $('#gen-input').val();
	if(n.length==0) {
		$('#p-value').text('');
		return;
	} 
	h = sha256(no + n);
	if(h.words[0]<0) h.words[0] = 0-h.words[0];
	$('#p-value').text(h.words[0]);
}

function checkLogin(e) {

	var key, n, p, h, ha, res, str, checkData;
	var no = 'gdsnboduwcglk';
	var noa = 'gfhksirlcgysbs';

	// if(e.charCode==13 || e.target.id=='login-butt') {
	// 	n = $('#login-input').val();
//if(n=='testuser') return;
		p = $('#pass-input').val();
		h = sha256(no + n);
		ha = sha256(noa + n);
		if(h.words[0]<0) h.words[0] = 0-h.words[0];
		if(ha.words[0]<0) ha.words[0] = 0-ha.words[0];
		if(p == ha.words[0] && ha.words[0]==State.super) {
			enterGen();
			return;
		}

		checkData = sha256(no + p).toString();
		str = '' + window.location;
		res = str.indexOf('calculatoroms.ru');
		if(res==-1) enterCalc();
//		if(p == h.words[0]) enterCalc();
		if(checkData == State.authToken) enterCalc();
		else console.log('Wrong!');
//	}
}


function enterCalc() {


	$('#section0').css({'opacity':0});
	$('.top').css({'opacity':0});
	$('.top').show();
	$('#section0').show();
	$('#section0').animate({'opacity':1}, 700);
	$('.top').animate({'opacity':1}, 700);
	$('#start-block').animate({'opacity':0}, 700, function(){
		$('#start-block').hide();
	});
	if(State.regionDataInit) {
		$('#title-block').animate({'top':'-680px', 'opacity':0}, 700, function(){
			State.regSelector.showRegs();
		});
	} else {
		State.regSelector.restoreRegData();
State.calc.fillKsgBuf();
State.mainTable.render();
	}
}

function hideLoadBanner() {

	$('.load-banner').animate({'opacity':0}, 700, function(){
		$('.load-banner').hide();
	});
}

function showSetupPanel() {

	if(State.flAnimate==1) return;
	State.flAnimate = 1;
	State.flModal = 1;
	$('#tool-menu').show();
	$('#tool-menu').animate({'opacity':1}, 700, function(){

	});

}

function closeSetupPanel() {

	$('#tool-menu').animate({'opacity':0}, 700, function(){
		State.flAnimate = 0;
		State.flModal = 0;
		$('#tool-menu').hide();
	});
}

function setupAction(e) {

	let action = e.target.id;

	closeSetupPanel();
	if(action=='reg-save-but') State.mainTable.renderFirstXls();
	if(action=='list-save-but') State.mainTable.renderSecondXls();
}

function switchPage(e) {

        var target, adrStr, hideSection, str;
        if(State.flAnimate>0) return;
        if(State.flSelection>0) return;
        if(State.flModal==1) return;
        hideSection = '#section' + State.currPage;
        target = e.target.id;
        str = target.slice(0,9);
        if(str=='setup-but') {
        	showSetupPanel();
        }
        if(str=='print-but') {
        	e.preventDefault();
        	State.printer.dataPrint();
        }
        if(str!='menu-butt') return;
        target = target.slice(-1);
        if(target==State.currPage) return;
        State.flAnimate = 2;
        $('#menu-butt'+State.currPage).addClass('inactive');
        $('#menu-butt'+State.currPage).removeClass('active');
        $('#menu-butt'+target).addClass('active');
        $('#menu-butt'+target).removeClass('inactive');
        $('#section'+target).css({'opacity':0, 'display':'block'});
        $('#section'+target).animate({'opacity':1}, 700, function(){
            State.flAnimate--;
        });
        $(hideSection).animate({'opacity':0}, 700, function(){
            $(hideSection).css({'display':'none'});
            State.currPage = target;
            State.flAnimate--;
        });
}

function saveSetup() {

	let dataStr, setupData = {}, lsName = 'mn_setup';

	// setupData.dbVersion = State.dbVersion;
	// setupData.trustMode = State.flTrastMode;
	// dataStr = JSON.stringify(setupData);
	// localStorage.setItem(lsName, dataStr);
}

function cleanStorage() {

	// localStorage.removeItem('mn_path');
	// localStorage.removeItem('mn_meth');
	// localStorage.removeItem('mn_store');
	// saveSetup();
	window.location.reload(true);
}

function loadSetup() {

	let dataSet, dataStr, setupData = {}, lsName = 'mn_setup';

	// dataSet = localStorage.getItem(lsName);
	// if(null == dataSet) {
	// 	cleanStorage();
	// 	return;
	// }
	// setupData = JSON.parse(dataSet);
	// if(setupData.dbVersion!=State.dbVersion) {
	// 	cleanStorage();
	// }
}